module.exports = __webpack_public_path__ + "media/images/logos/facebook-e2d60dcb1716d67a7369496b7180357a.svg";